var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { api } from '../../helpers/Api';
import { action, computed, observable } from 'mobx';
export default class AforoStore {
    constructor() {
        this.getAforo = (data) => {
            const stretch_id = data.stretch_id;
            delete data.stretch_id;
            return api.post(`aforo/${stretch_id}`, Object.assign({}, data)).then(value => {
                this.setQuantityUsed(value);
                this.setUnitUsed(value);
                return value;
            });
        };
        this.setQuantityUsed = (value) => {
            this._quantityUsed = value.quantityUsed;
        };
        this.setUnitUsed = (value) => {
            this._unitUsed = value.unitUsed;
        };
    }
    set capacity(value) {
        this._capacity = value;
    }
    get quantityUsed() {
        return this._quantityUsed;
    }
    get quantityAvailable() {
        return this._capacity - this._quantityUsed;
    }
    set unit(value) {
        this._unit = value;
    }
    get unitUsed() {
        return this._unitUsed;
    }
    get unitAvailable() {
        return this._unit - this.unitUsed;
    }
}
__decorate([
    observable
], AforoStore.prototype, "_quantityUsed", void 0);
__decorate([
    observable
], AforoStore.prototype, "_unitUsed", void 0);
__decorate([
    action
], AforoStore.prototype, "setQuantityUsed", void 0);
__decorate([
    computed
], AforoStore.prototype, "quantityAvailable", null);
__decorate([
    action
], AforoStore.prototype, "setUnitUsed", void 0);
__decorate([
    computed
], AforoStore.prototype, "unitAvailable", null);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Aforos/AforoStore.ts
// module id = 575
// module chunks = 0